import { css } from "office-ui-fabric-react";
import "./AbbreviationIcon.css";
import * as React from "react";

type Props = {
    abbreviation: string;
    title: string;
    className?: string;
}
const AbbreviationIcon = (props: Props) => <div className={css("abbreviation-icon", props.className)} title={props.title}><span>{props.abbreviation}</span></div>
export default AbbreviationIcon;